import { render, staticRenderFns } from "./on-job.vue?vue&type=template&id=1837fba2&scoped=true"
import script from "./on-job.vue?vue&type=script&lang=ts"
export * from "./on-job.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1837fba2",
  null
  
)

export default component.exports